// For Firebase JS SDK v7.20.0 and later, measurementId is optional
// export const firebaseConfig = {
//   apiKey: "AIzaSyB_yfV7fOfpu8-mGfqrGrs_VybREn8dU8g",
//   authDomain: "project-web-spa.firebaseapp.com",
//   databaseURL: "https://project-web-spa.firebaseio.com",
//   projectId: "project-web-spa",
//   storageBucket: "project-web-spa.appspot.com",
//   messagingSenderId: "888033226301",
//   appId: "1:888033226301:web:cce79bea5559a795288454",
//   measurementId: "G-3H7F209LLX"
// };
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
export const firebaseConfig = {
  apiKey: "AIzaSyCeVjU3y9j5KmLcBuac72vaH5FHHtovO6g",
  authDomain: "wadahkode.firebaseapp.com",
  databaseURL: "https://wadahkode.firebaseio.com",
  projectId: "wadahkode",
  storageBucket: "wadahkode.appspot.com",
  messagingSenderId: "631419553233",
  appId: "1:631419553233:web:3770606a54e8c8f3d28cf0",
  measurementId: "G-TSQTB588PQ"
};